import { useEffect, useRef } from "react";

import { BaseTable } from "@/components/shared/data-table";
import { ServerSideDataTablePagination } from "@/components/shared/tables/server-side-table-pagination";
import { ErrorMessage } from "@/components/ui/error";

import { ChartOfAccountsDrawer } from "./drawer";
import type { ChartOfAccountsTableInstance } from "./use-chart-of-accounts-table";

type Props = ChartOfAccountsTableInstance;

export const ChartOfAccountsTable = (props: Props) => {
  const tableRef = useRef(null);

  const {
    table,
    clickableColumns,
    columnVisibility,
    columns,
    data,
    stickyColumns,
    footer,
    loading,
    error,
    pagination,
    handleRowClick,
    handlePageChange,
    handlePageSizeChange,
    limit,
    focusedRowId,
  } = props;

  const handleDrawerClose = () => {
    table.setFocusedRow(undefined);
  };

  if (error) {
    return (
      <div className="flex justify-center items-center h-screen">
        <ErrorMessage message={error.message} />
      </div>
    );
  }

  return (
    <>
      <div className="h-full flex flex-row">
        <div className="relative flex-1">
          <div className="flex flex-col gap-2 h-full w-full">
            <BaseTable
              table={table}
              clickableColumns={clickableColumns}
              columnVisibility={columnVisibility}
              columns={columns}
              data={data}
              stickyColumns={stickyColumns}
              footer={footer}
              loading={loading}
              ref={tableRef}
              onRowClick={handleRowClick}
            />
            <div className="mt-0.5" />
            <ServerSideDataTablePagination
              table={table}
              totalItems={pagination.totalItems}
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              pageSize={limit}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
            />
          </div>
        </div>
      </div>
      <ChartOfAccountsDrawer
        focusedRowId={focusedRowId}
        onClose={handleDrawerClose}
      />
    </>
  );
};
